import React = require('react');
import { useState } from 'react';

export const EnhancedTripDisruptionMoreInfo = ({ infoText }) => {

  const [showMoreInfo, setShowMoreInfo] = useState(false);

  const changeShowMoreInfo = () => {
    setShowMoreInfo(!showMoreInfo)
  }

  return (
        <>
          <div className="margin-bottom">
            As standard your policy covers delays of 12 hours or more. Our Enhanced Trip Disruption cover means you're protected if your transport to or from the UK is delayed for 6 hours of more.  Would you like to add Enhanced Trip Disruption to your policy?
          </div>
          <table className="comparison-table margin-bottom">
            <thead>
            <tr>
              <th>Cover</th>
              <th>Standard Cover</th>
              <th>Enhanced Trip Disruption</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                Cover for connecting flights on your outbound and return journey
                (including mid-trip connection)
              </td>
              <td className="icon-cell">
                <img
                  src={require('../../../../../Quote/img/red-cross-circle.png')}
                  alt=""
                />
              </td>
              <td className="icon-cell">
                <img
                  src={require('../../../../../Quote/img/green-tick-circle.png')}
                  alt=""
                />
              </td>
            </tr>

            <tr>
              <td>
                Cover if your trip is delayed or disrupted because of:
                <ul>
                  <li>air traffic control issues</li>
                  <li>airspace closures</li>
                  <li>technical issues</li>
                  <li>airline crew have gone over their allowed working hours</li>
                  <li>you’re denied boarding due to overbooking</li>
                </ul>
              </td>
              <td className="icon-cell">
                <img
                  src={require('../../../../../Quote/img/red-cross-circle.png')}
                  alt=""
                />
              </td>
              <td className="icon-cell">
                <img
                  src={require('../../../../../Quote/img/green-tick-circle.png')}
                  alt=""
                />
              </td>
            </tr>
            <tr>
              <td>
                Cover if your delay is 6 hours or more, as well as up to £500 to help
                you continue your journey
              </td>
              <td className="icon-cell">
                <img
                  src={require('../../../../../Quote/img/red-cross-circle.png')}
                  alt=""
                />
              </td>
              <td className="icon-cell">
                <img
                  src={require('../../../../../Quote/img/green-tick-circle.png')}
                  alt=""
                />
              </td>
            </tr>
            </tbody>
          </table>
          <div className="margin-bottom">
            For full details of what's covered, and what isn't, take a look <a className="pointer" href={'https://www.admiral.com/travel-insurance/travel-disruption-insurance'} target={'_blank'}>here</a>
          </div>
          <div className="margin-bottom">
            <span className={'more-info'} onClick={changeShowMoreInfo}>{showMoreInfo ? ' Less information' : ' More information'}</span>
          </div>
          {showMoreInfo && (
            <>
              <div className="bold margin-bottom">Standard cover:</div>
              <div className="margin-bottom">When your delay reaches 12 hours, you'll get £25 for each full 12-hour delay period. You're covered for delays caused by:</div>
              <ul className="margin-bottom">
                <li>Mechanical breakdowns</li>
                <li>Industrial action or strikes</li>
                <li>Severe weather</li>
              </ul>
              <div className="margin-bottom">If your trip is cancelled or delayed by 12 hours or more, and there’s no alternative transport available, you are covered for abandoning your trip.</div>
              <div className="margin-bottom">Your policy won't cover:</div>
              <ul>
                <li>Missed connections or missed international departures that don't leave from, or arrive in, the UK.</li>
                <li>Delays to connecting flights or transport that doesn't leave from, or arrive in, the UK.</li>
              </ul>
            </>
          )}
        </>
  )
}
